import { TimeWindowPickerInputGroup } from '@/react/portainer/environments/common/TimeWindowPicker/TimeWindowPickerInputGroup';

import { SwitchField } from '@@/form-components/SwitchField';
import { FormSection } from '@@/form-components/FormSection';

import { DockerSetupFormData } from './types';

interface SectionProps {
  formData: DockerSetupFormData;
  onChange: <K extends keyof DockerSetupFormData>(
    key: K,
    value: DockerSetupFormData[K]
  ) => void;
}

interface TimeWindowSectionProps extends SectionProps {
  timeZone: string;
  onChangeTimeZone: (timeZone: string) => void;
}

export function TimeWindowSection({
  formData,
  onChange,
  timeZone,
  onChangeTimeZone,
}: TimeWindowSectionProps) {
  return (
    <FormSection title="Change window settings">
      <div className="form-group">
        <div className="col-sm-12">
          <SwitchField
            checked={formData.changeWindow.Enabled}
            onChange={(value) =>
              onChange('changeWindow', {
                ...formData.changeWindow,
                Enabled: value,
              })
            }
            label="Enable Change Window"
            tooltip="GitOps updates to stacks or applications outside the defined change window will not occur."
            labelClass="col-sm-7 col-lg-4"
            data-cy="enable-change-window-switch"
          />
        </div>
      </div>

      {formData.changeWindow.Enabled && (
        <>
          <div className="form-group">
            <div className="col-sm-12">
              <TimeWindowPickerInputGroup
                values={formData.changeWindow}
                onChangeTimeZone={onChangeTimeZone}
                onChangeChangeWindow={(changeWindow) =>
                  onChange('changeWindow', changeWindow)
                }
                timeZone={timeZone}
              />
            </div>
          </div>
          <div className="form-group">
            <div className="col-sm-12">
              <span className="text-warning small flex gap-1 align-top">
                <div className="icon icon-sm">
                  <i className="fa fa-exclamation-triangle" />
                </div>
                <div>
                  GitOps updates to stacks or applications outside the defined
                  change window will not occur.
                </div>
              </span>
            </div>
          </div>
        </>
      )}
    </FormSection>
  );
}
